// Third party import
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { getToLocalStorage, setToLocalStorage } from "../../Library/Utils";

import {
  IFeedbackList,
  IselecedOverviewDetails,
  ISelectedPerson,
  ISetPersonActionPayload,
  FeedbackState,
  conditionFormationType} from "../../types/feedback";

import { feedbackData } from "../../StaticData/feedbackData";

const currentDate = new Date();
const localCurrentYeat = getToLocalStorage("feedbackYear");
const currentYear = localCurrentYeat || currentDate.getFullYear()?.toString();
const currentMonth = currentDate.getMonth() + 1;
const currentQuarter = Math.ceil(currentMonth / 3)?.toString();

const initialState: FeedbackState = {
  selectedQuarter: currentQuarter,
  selectedYear: currentYear,
  selectedFeedbackId: "",
  selectedPerson: getToLocalStorage("feedbackResponsiblePerson") || {
    id: "",
    firstName: "",
    lastName: "",
    c_level: false,
    ceo_level: false,
    profile_image: "",
    profile_color_hash: "",
    created_at: ""},
  listFeedback: getToLocalStorage("listFeedback") || [],
  selecedOverviewDetails:
    getToLocalStorage("selecedFeedbackOverviewDetails") ||
    feedbackData.emptyFeedback,
  callFeedbackList: true,
  isLoadingFeedback: true,
  conditionFormation: []};

export const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    setSelectedFeedbackQuarter: (
      state: { selectedQuarter: string },
      action: PayloadAction<string>
    ) => {
      state.selectedQuarter = action.payload;
    },
    setSelectedFeedbackYear: (
      state: { selectedYear: string },
      action: PayloadAction<string>
    ) => {
      state.selectedYear = action.payload;
    },
    setSelectedFeedbackId: (
      state: { selectedFeedbackId: string },
      action: PayloadAction<string>
    ) => {
      state.selectedFeedbackId = action.payload;
    },
    setSelectedPerson: (
      state: { selectedPerson: ISelectedPerson },
      action: PayloadAction<ISetPersonActionPayload>
    ) => {
      const { payload, reset } = action.payload;
      if (reset) state.selectedPerson = initialState.selectedPerson;
      else state.selectedPerson = { ...state?.selectedPerson, ...payload };
    },
    setListFeedback: (
      state: { listFeedback: IFeedbackList },
      action: PayloadAction<IFeedbackList>
    ) => {
      state.listFeedback = action.payload;
      setToLocalStorage("listFeedback", JSON.stringify(action.payload));
    },
    setSelecedOverviewDetails: (
      state: { selecedOverviewDetails: IselecedOverviewDetails },
      action: PayloadAction<IselecedOverviewDetails>
    ) => {
      state.selecedOverviewDetails = action.payload;
    },
    setCallFeedbackList: (
      state: { callFeedbackList: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.callFeedbackList = action.payload;
    },
    setIsLoadingFeedback: (
      state: { isLoadingFeedback: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.isLoadingFeedback = action.payload;
    },
    setConditionFormation: (
      state: { conditionFormation: conditionFormationType[] },
      action: PayloadAction<conditionFormationType[]>
    ) => {
      state.conditionFormation = action.payload;
    }}});

export const {
  setSelectedFeedbackQuarter,
  setSelectedFeedbackYear,
  setSelectedFeedbackId,
  setSelectedPerson,
  setListFeedback,
  setSelecedOverviewDetails,
  setCallFeedbackList,
  setIsLoadingFeedback,
  setConditionFormation} = feedbackSlice.actions;

export default feedbackSlice.reducer;
